import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Box, Button, Container, Grid, Typography, useTheme, useMediaQuery, styled } from '@mui/material';
import { ArrowForwardIos as ArrowForwardIcon } from '@mui/icons-material';
import { comingOfAgeData } from "../../utils/BeadsData";

const ComingOfAge = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const ReadMoreLink = styled(RouterLink)(({ theme }) => ({
        textDecoration: 'none',
        color: theme.palette.primary.main,
        '&:hover': {
            color: '#f39c12',
        },
    }));

    return (
        <Box>
            <NavBar />
            <Container sx={{ mt: 12, mx: 'auto', mb: 5 }}>
                <Typography variant="h3" gutterBottom sx={{ my: 3, textAlign: 'center', fontWeight: 'bold' }}>Coming of Age</Typography>

                <Typography paragraph>
                    BEADS is committed to assisting the Maasai keep the beautiful ceremony that signifies a girl's passage into womanhood, but without the FGM that has accompanied it in the past.
                </Typography>

                <Grid container spacing={5} justifyContent="center" sx={{ mt: 1 }}>
                    <Grid item xs={12} md={8}>
                        <Swiper
                            modules={[Autoplay, EffectFade]}
                            effect="fade"
                            autoplay={{ delay: 5000, disableOnInteraction: false }}
                            loop={true}
                            style={{ borderRadius: '2rem' }}
                        >
                            {comingOfAgeData.map((image, index) => (
                                <SwiperSlide key={index}>
                                    <Box sx={{ position: 'relative', height: isMobile ? 340 : 550 }}>
                                        <img src={image.src} alt={image.alt}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        <Typography
                                            variant={isMobile ? "body2" : "subtitle1"}
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: '100%',
                                                color: 'white',
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                padding: '6px',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {image.description}
                                        </Typography>
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Grid>

                    <Grid item xs={12} md={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: isMobile ? 3 : 15 }}>
                        <Box sx={{ width: '100%', p: 3, textAlign: 'center', borderRadius: '1.5rem', background: '#f8fafd', border: '1px solid #cfcfcf' }}>
                            <Typography variant="body1" paragraph>
                                YOU CAN HELP ERADICATE FGM IN OUR REGIONS BY DONATING TO AN ALTERNATIVE RITES OF PASSAGE CEREMONY WITHOUT THE CUT.
                            </Typography>
                            <Button className='btn btn-border-base' variant="outlined" onClick={() => navigate('/donate')} sx={{ mt: 2, borderRadius: 15, color: '#f39c12' }}>
                                Learn More
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            <Grid container direction="column" alignItems="center" sx={{ my: 5, mx: 'auto', p: 3, background: '#f8f9fc', boxShadow: '3px 4px 8px rgba(0,0,0,0.1)' }}>
                <Typography variant="h5" gutterBottom align="center" fontWeight="bold">ESTHER'S STORY</Typography>
                <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Typography variant="subtitle1" color="text.secondary" sx={{ display: 'inline' }}>
                        Esther is a BEADS sponsored girl aged approximately 13 years. She is sponsored by BEADS and is in 9th grade at Rombo Girls School in Loitokitok, Kenya. She is on her term two break from school, and it is time for her to graduate from one stage to another — from childhood to adulthood...
                    </Typography>
                    <ReadMoreLink to='/esthers-story' style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '4px' }}>
                        Read More <ArrowForwardIcon sx={{ fontSize: '1rem' }} />
                    </ReadMoreLink>
                </Box>
            </Grid>
            <FooterOne />
        </Box>
    );
};

export default ComingOfAge;